import { Switch, useRouteMatch } from 'react-router-dom';

import { PermissionType } from 'hrm-common/extensions/enums/personel';
import { PrivateRoute } from 'routes/PrivateRoute';
import { EmployeeDashboard } from './pages';

export default function DashboardEmployee() {
  const match = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute path={match.path} exact permissions={[PermissionType.PERSONNEL_MANAGE]}>
        <EmployeeDashboard />
      </PrivateRoute>
    </Switch>
  );
}
